<template>
  <div id="EnergyDataConfig">
    <div class="title">
      <div>数据源设置</div>
    </div>
    <div class="table-box">
      <el-form :rules="rules" ref="EnergyDataConfig" class="clearfix" :model="ruleForm" :disabled="false">
        <p class="item-title">能源参数设置</p>
        <el-form-item prop="water" label="用水量：" autocomplete="off" style="margin-left: 28px;">
          <el-cascader :props="props" v-model="ruleForm.water" clearable></el-cascader>
        </el-form-item>
        <el-form-item prop="gas" label="用气量：" autocomplete="off" style="margin-left: 28px;">
          <el-cascader :props="props" v-model="ruleForm.gas" clearable></el-cascader>
        </el-form-item>
        <el-form-item prop="thermal" label="用热量：" autocomplete="off" style="margin-left: 28px;">
          <el-cascader :props="props" v-model="ruleForm.thermal" clearable></el-cascader>
        </el-form-item>
        <!-- <p class="item-title">小时单位能耗属性设置</p>
        <el-form-item prop="hosr" label="小时单位能耗：" autocomplete="off" style="margin-left: 28px;">
          <el-cascader :props="props" v-model="ruleForm.hosr"></el-cascader>
        </el-form-item>
        <el-form-item prop="day" label="昨日单位能耗：" autocomplete="off" style="margin-left: 28px;">
          <el-cascader :props="props" v-model="ruleForm.day"></el-cascader>
        </el-form-item> -->
        <p class="item-title">统计属性设置</p>
        <el-form-item prop="gasTotal" label="统计属性1：" autocomplete="off" style="margin-left: 28px;">
          <el-cascader :props="props" v-model="ruleForm.gasTotal" clearable></el-cascader>
        </el-form-item>
        <el-form-item prop="gasYear" label="统计属性2：" autocomplete="off" style="margin-left: 28px;">
          <el-cascader :props="props" v-model="ruleForm.gasYear" clearable></el-cascader>
        </el-form-item>
        <el-form-item prop="gasMonth" label="统计属性3：" autocomplete="off" style="margin-left: 28px;">
          <el-cascader :props="props" v-model="ruleForm.gasMonth" clearable></el-cascader>
        </el-form-item>
        <el-form-item prop="gasDay" label="统计属性4：" autocomplete="off" style="margin-left: 28px;">
          <el-cascader :props="props" v-model="ruleForm.gasDay" clearable></el-cascader>
        </el-form-item>
      </el-form>
      <div class="btn" >
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        ruleForm: {
          water:[],
          gas:[],
          thermal:[],
          // hosr:[],
          // day:[],
          gasTotal:[],
          gasYear:[],
          gasMonth:[],
          gasDay:[],
        },
        rules: {
          water:[{ required: false, message: '请选择用水量', trigger: 'blur' }],
          gas:[{ required: false, message: '请选择用气量', trigger: 'blur' }],
          thermal:[{ required: false, message: '请选择用热量', trigger: 'blur' }],
          hosrId:[{ required: false, message: '请选择小时单位能耗', trigger: 'blur' }],
          dayId:[{ required: false, message: '请选择昨日单位能耗', trigger: 'blur' }],
          gasTotal:[{ required: false, message: '请选择总用气量', trigger: 'blur' }],
          gasYear:[{ required: false, message: '请选择年用气量', trigger: 'blur' }],
          gasMonth:[{ required: false, message: '请选择月用气量', trigger: 'blur' }],
          gasDay:[{ required: false, message: '请选择日用气量', trigger: 'blur' }],
        },
        datasetList:[],
        deviceList:[],
        props:{
          label:'name',
          value:'code',
          lazy: true,
          lazyLoad:this.loadAttr
        }
      }
    },
    created() {
      this.$store.state.energyIndex = '/Energy/EnergyDataConfig'
      this.getConfig()
      this.getDatesetList()
    },
    methods: {
        getConfig(){
          this.get('/EnergyConfig/getConfig',{companyId:this.$store.state.companyId}).then(res=>{
            if(res.success){
              for(let obj of res.result){
                if(obj.name == 'other'){
                  this.ruleForm = JSON.parse(obj.value)
                }
              }
            }else{
              this.$message({
                type:'warning',
                message:"获取配置失败：" + res.message
              })
            }
          })
        },

      save(){
        this.$refs.EnergyDataConfig.validate((valid) => {
          if(valid){
            // return
            this.post('/EnergyConfig/setConfig',{companyId:this.$store.state.companyId,name:"other",value:JSON.stringify(this.ruleForm)}).then(res=>{
              if(res.success){
                this.$message({
                  type:'success',
                  message:"配置成功"
                })
              }else{
                this.$message({
                  type:'warning',
                  message:"配置失败：" + res.message
                })
              }
            })
          }
        })
      },
      getDatesetList(){
        this.get('/Dataset/getList',{code:this.$store.state.companyCode}).then((res)=>{
          if(res.success){
            this.datasetList = res.result
          }else{
            this.$message({
              type:"warning",
              message:`获取数据集失败:${res.message}`
            })
          }
        })
      },
      //  getDeviceList(){
      //   this.get('/Device/getList',{companyId:this.$store.state.companyId}).then((res)=>{
      //     if(res.success){
      //       console.log(res.result)
      //       return res.result
      //     }else{
      //       this.$message({
      //         type:"warning",
      //         message:`获取数据集失败:${res.message}`
      //       })
      //       return []
      //     }
      //   })
      // },
      loadAttr(node,resolve){
        if(node.level==0){
          let data = []
          this.get('/Device/getList',{companyId:this.$store.state.companyId}).then((res)=>{
            if(res.success){
              data = res.result
            }else{
              this.$message({
                type:"warning",
                message:`获取设备列表失败:${res.message}`
              })
            }
            this.get('/VirtualDevice/get',{companyId:this.$store.state.companyId}).then((r)=>{
              if(res.success){
                r.result.name = '虚拟设备'
                data.unshift(r.result)
              }else{
                this.$message({
                  type:"warning",
                  message:`获取虚拟设备失败:${res.message}`
                })
              }
              resolve(data)
            })
          })
        }else if(node.level==1){
          let data = [],device = node.data
          if(device.code.substring(0,2)=='_V'&&(device.id||device.id == 0)){
            this.get('/VirtualDevice/getPropertyList',{deviceId:device.id}).then((res)=>{
              if(res.success){
                for(let attr of res.result){
                  attr.leaf = node.level >=1
                  data.push(attr)
                }
                resolve(data)
              }else{
                this.$message({
                  type:"warning",
                  message:`获取设备属性失败:${res.message}`
                })
              }
              resolve([])
            })
          }else{
            this.get('/ProductFeature/getByDeviceCode',{code:device.code}).then((res)=>{
              if(res.success){
                let propertyArr = device.propertySet.split(','),
                proData = JSON.parse(res.result).properties
                for(let properties of proData){
                  if(propertyArr.includes(properties.identifier)){  //
                  properties.code = properties.identifier
                  properties.leaf = node.level >=1
                   data.push(properties)
                  }
                }
                resolve(data)
              }else{
                this.$message({
                  type:"warning",
                  message:`获取设备属性失败:${res.message}`
                })
              }
              resolve([])
            })
          }

        }
        this.$nextTick(()=>{
          this.$forceUpdate()
        })
      }
    }
  }
</script>

<style scoped>
  .btn{
    text-align: center;
  }
  .item-title{
    font-size: 14px;
    margin-bottom: 20px;
  }
  .table-box {
    width: 500px;
    padding: 20px;
    background-color: #ffffff;
    text-align: left;
    margin-left: 20px;
  }
  .title {
    text-align: left;
    font-size: 14px;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Energy/EnergyDataConfig.vue